import React, { useEffect } from "react";
import styled from "styled-components";
import Header from "@/components/Header";

import Star from './imgs/star@2x.png';
import DeclaimImg from './imgs/declaim@2x.png';
import MainBg from './imgs/main-bg@2x.png';

import ArchiveBg from './imgs/archive-bg@2x.png'; 
import ArchiveStart from './imgs/archive-start@2x.png';
import ArchiveReplay from './imgs/archive-replay@2x.png';

import bwmodel from '@/config/bwmodel';
import { activityShare, isStorm, handleUploadTrace } from './stock';

const HomePage = ({ replay, readArchive, archiveMonth }) => {
  const month = Number(`${archiveMonth}`.slice(4, 6));

  const handleStart = () => {
    readArchive(month);
  }

  const handleReplay = () => {
    replay();
  };

  useEffect(() => {
    handleUploadTrace('load', 'visitor');
  }, []);

  return (
    <Container>
      {isStorm && 
        <Header
          title="重生之股神模拟器"
          right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
        />
      }
      <div className={`page-body ${!isStorm ? 'hide-header' : ''}`}>
        <div className="page-content">
          <img src={MainBg} className='main-bg' alt=''/>
          <img src={DeclaimImg} alt='' className="declaim-img" />
          <img src={DeclaimImg} alt='' className="declaim-img-footer" />
          <div className="poster-img-wrap">
            <img src={Star} alt='' className="star-img"/>
            <img src={Star} alt='' className="star-img star-img-top"/>
          </div>
          <div className="content-img-wrap">
            <div className="start-btn-wrap">
              <div className="content-btns">
                <img onClick={readArchive} src={ArchiveBg} alt='' className="content-img"/>
                <div className="start-btn">
                  <div className="start-btn-box">
                    <div className="start-btn-img" onClick={handleStart}>
                      <div>继续</div>
                      <div className="start-label">重回2023年{month}月</div>
                    </div>
                    <div src={ArchiveReplay} className={`start-btn-text`} onClick={handleReplay}>
                      重新开始
                    </div>
                    {/* <img src={Star} alt='' className="star-img"/> */}
                  </div>
                </div>
                <img src={Star} alt='' className="star-img-decor"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default React.memo(HomePage);

const Container = styled.div`
  .page-content {
    display: flex;
    flex-direction: column;
  }
  .poster-img-wrap {
    position: relative;
    .star-img {
      width: 32px;
      height: 32px;
      position: absolute;
      z-index: 4;
      right: 98px;
      top: 44px;
    }
    .star-img-top {
      width: 37.9px;
      height: 37.9px;
      right: 152px;
      top: 14px;
    }
  }
  .content-img-wrap {
    padding: 0 5px;
    position: relative;
    top: -32px;
    flex: 1;
    .content-img {
      width: 100%;
    }
    .start-btn-wrap {
      width: 100%;
      height: 100%;
      position: relative;
      padding-top: 40px;
      max-height: calc(100% - 40px);
      .content-btns {
        position: relative;
      }
      .star-img-decor {
        width: 49px;
        height: 49px;
        position: absolute;
        z-index: 4;
        right: 20px;
        bottom: 60px;
      }
      .start-btn {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 9;
        left: 0px;
        top: 0px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .start-btn-box {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-bottom: 60px;
          .star-img {
            width: 49px;
            height: 49px;
            position: absolute;
            z-index: 4;
            right: -48px;
            top: -22px;
          }
        }
        .start-btn-img {
          width: 199px;
          height: 85px;
          background-image: url(${ArchiveStart});
          background-repeat: no-repeat;
          background-size: 100% 100%;
          font-size: 26px;
          font-weight: normal;
          color: #000000;
          line-height: 26px;
          text-align: center;
          box-sizing: border-box;
          padding-top: 18px;
          .start-label {
            font-size: 18px;
            line-height: 18px;
            margin-top: 6px;
          }
        }
        .start-btn-text {
          width: 199px;
          height: 66px;
          background-image: url(${ArchiveReplay});
          background-repeat: no-repeat;
          background-size: 100% 100%;
          margin-top: 10px;
          font-size: 26px;
          font-weight: normal;
          color: #000000;
          line-height: 66px;
          text-align: center;
        }
      }
    }
  } 
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/read-archive.js